<template>
  <div id="app-about-contact-us">
    <h1>联系我们 <em class="el-icon-s-promotion"></em></h1>
    <div style="width: 600px;margin: auto">
      <el-form :model="contactUs">
        <el-form-item label="联系方式">
          <el-input placeholder="可以是邮箱,联系电话，QQ等" v-model="contactUs.way"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" placeholder="请输入内容" :autosize="{ minRows: 4, maxRows: 5}"
                    v-model="contactUs.textarea" maxlength="200" resize="none" show-word-limit></el-input>
        </el-form-item>
        <el-button type="primary" style="width: 100%;background: #ff8a00;border: 0">提交</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      contactUs: {
        textarea: '',
        way: ''
      },
      index: 9
    }
  }
}
</script>

<style scoped>

#app-about-contact-us {
  width: 100%;
  text-align: center;
  /*padding: 15px 15px 50px;*/
}

</style>